import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('bb_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const adminPw = sessionStorage.getItem('bb_admin_pw');
  if (adminPw) cfg.headers['X-Admin-Password'] = adminPw;
  return cfg;
});

export default api;

export const formatPrice = (n) => `\u20B9${Number(n).toLocaleString('en-IN')}`;
